// Body types the vehicle filter and the `acriss` URL param work with. Lives here rather than in
// Filter.tsx so GetUrlParams and dataContext can use it without importing the filter hook.
export enum VehicleType {
    Compact = 'compact', // url param: acriss=1
    StationWagon = 'stw', // ""=2
    SUV = 'suv', // ""=3
    Minibus = 'minibus', // ""=4
    Van = 'van', // ""=5
}
